document.addEventListener('DOMContentLoaded', function () {
    const BLOG_LIMIT = 20;

    // FILTER ARTICLES
    document.querySelectorAll('.filter-buttons button').forEach((button) => {
        button.addEventListener('click', function () {
            // Set active class
            document.querySelectorAll('.filter-buttons button').forEach((btn) => btn.classList.remove('active'));
            this.classList.add('active');

            const filter = this.getAttribute('data-filter');
            const handleUrl = this.getAttribute('data-handle-url');
            let count = 0;
            let filteredPosts = [];

            // Filter posts by category
            document.querySelectorAll('.blog-post').forEach((post) => {
                if (filter === 'all' || post.dataset.category.includes(filter)) {
                    filteredPosts.push(post);
                    count++;
                } else {
                    post.style.display = 'none';
                }
            });

            // Display first 20 or all depending on filter
            filteredPosts.forEach((post, index) => {
                post.style.display = (filter === 'all' && index >= BLOG_LIMIT) ? 'none' : 'block';
            });

            // Update count
            document.querySelectorAll('#filtered-article-count').forEach(el => {
                el.textContent = count;
            });

            // Sort after filtering
            sortArticles(document.querySelector('.sortblogs').value);

            // View All Button logic
            const viewAllBtn = document.querySelector('.blogs_view_all__button');

if (filter === 'all') {
    const isShowingAll = viewAllBtn.getAttribute('data-showing-all') === 'true';

    // Toggle visibility based on current state
    filteredPosts.forEach((post, index) => {
        post.style.display = (!isShowingAll && index >= BLOG_LIMIT) ? 'none' : 'block';
    });

    // Set button text and display
    if (count > BLOG_LIMIT) {
        viewAllBtn.style.display = 'flex';
        viewAllBtn.textContent = isShowingAll ? 'View Less' : 'View All';
        viewAllBtn.href = '#';

        const newBtn = viewAllBtn.cloneNode(true);
        viewAllBtn.parentNode.replaceChild(newBtn, viewAllBtn);

        newBtn.setAttribute('data-showing-all', !isShowingAll);

        newBtn.addEventListener('click', function (e) {
            e.preventDefault();

            const showAll = this.getAttribute('data-showing-all') !== 'true';

            filteredPosts.forEach((post, index) => {
                post.style.display = (showAll || index < BLOG_LIMIT) ? 'block' : 'none';
            });

            this.textContent = showAll ? 'View Less' : 'View All';
            this.setAttribute('data-showing-all', showAll);
        });
    } else {
        viewAllBtn.style.display = 'none';
    }
} else {
    // Redirect to category blog page on click
    viewAllBtn.style.display = count > 0 ? 'flex' : 'none';
    viewAllBtn.textContent = 'View All';
    viewAllBtn.href = '/blogs/' + handleUrl;

    const newBtn = viewAllBtn.cloneNode(true);
    viewAllBtn.parentNode.replaceChild(newBtn, viewAllBtn);
}
        });
    });

    // SORTING
    document.querySelectorAll('.sortblogs').forEach((dropdown) => {
        dropdown.addEventListener('change', function () {
            sortArticles(this.value);
        });
    });

    function sortArticles(sortBy) {
        const container = document.querySelector('.blog-list');
        const posts = Array.from(container.children);

        posts.sort((a, b) => {
            const dateA = new Date(a.dataset.date);
            const dateB = new Date(b.dataset.date);
            return sortBy === 'date-desc' ? dateB - dateA : dateA - dateB;
        });

        posts.forEach(post => container.appendChild(post)); // Reorder in DOM
    }

    // On page load: trigger "All" filter
    const defaultAllBtn = document.querySelector('.filter-buttons button[data-filter="all"]');
    if (defaultAllBtn) {
        defaultAllBtn.click();
    }
});